import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        redirectTo: 'admin/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./features/admin/admin.routes').then((m) => m.adminRoutes),
      },
      {
        path: 'requisitions',
        loadChildren: () =>
          import('./features/requisitions/requisitions.routes').then(
            (m) => m.requisitionsRoutes,
          ),
      },
      {
        path: 'purchase-order',
        loadChildren: () =>
          import('./features/purchase-order/purchase-order.routes').then(
            (m) => m.purchaseOrderRoutes,
          ),
      },
      {
        path: 'grn',
        loadChildren: () =>
          import('./features/grn/grn.routes').then((m) => m.grnRoutes),
      },
      {
        path: 'invoice',
        loadChildren: () =>
          import('./features/invoice/invoice.routes').then(
            (m) => m.invoiceRoutes,
          ),
      },
      {
        path: 'stock-file',
        loadChildren: () =>
          import('./features/stock-file/stock-file.routes').then(
            (m) => m.stockFileRoutes,
          ),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./features/account/account.routes').then((m) => m.accountRoutes),
      },
      {
        path: 'download-approved-req/attachment',
        loadComponent: () =>
          import('./shared/components/download-approved-req/download-approved-req.component').then(
            (m) => m.DownloadApprovedReqComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
